import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=264b36da"
import script from "./AvatarSelector.vue?vue&type=script&lang=js"
export * from "./AvatarSelector.vue?vue&type=script&lang=js"
import style0 from "./AvatarSelector.vue?vue&type=style&index=0&id=264b36da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports